import { CheckCircle2, Clock, AlertTriangle, Hourglass, MoonStar } from 'lucide-react';
import type { IntegrationHealthState } from '../../api/dataApi';
import { healthCopy } from '../../lib/integrationHealth';

// Icon + text, never colour alone (brief: "every health state includes text
// and an icon").
const icon: Record<IntegrationHealthState, typeof CheckCircle2> = {
  healthy: CheckCircle2,
  waiting: Hourglass,
  no_recent: MoonStar,
  delayed: Clock,
  attention: AlertTriangle,
};

const color: Record<IntegrationHealthState, string> = {
  healthy: 'text-emerald-600 dark:text-emerald-400',
  waiting: 'text-black/50 dark:text-white/50',
  no_recent: 'text-black/50 dark:text-white/50',
  delayed: 'text-amber-600 dark:text-amber-400',
  attention: 'text-red-600 dark:text-red-400',
};

export function HealthPill({ state, title }: { state: IntegrationHealthState; title?: string }) {
  const Icon = icon[state];
  return (
    <span
      className={`inline-flex items-center gap-1 shrink-0 rounded-full border border-black/10 dark:border-white/15 px-2 py-0.5 text-[11px] font-medium ${color[state]}`}
      title={title ?? healthCopy[state].description}
    >
      <Icon size={12} aria-hidden />
      {healthCopy[state].label}
    </span>
  );
}
